var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldingEntities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12461_206951)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163 70H213C226.807 70 238 81.1929 238 95V95",
    stroke: "#D6FFFD",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107 70H53C39.1929 70 28 81.1929 28 95V95",
    stroke: "#D6FFFD",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 101V100C193 83.4315 179.569 70 163 70H142C137.029 70 133 65.9706 133 61V50",
    stroke: "#D6FFFD",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 101V100C72 83.4315 85.4315 70 102 70H124C128.971 70 133 65.9706 133 61V50",
    stroke: "#D6FFFD",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12461_206951)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.956 60.9182L133 108.002",
    stroke: "#D6FFFD",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_12461_206951",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.04 26C129.458 26 126.582 28.8756 126.582 32.4573C126.582 36.0403 129.458 38.916 133.04 38.916C136.622 38.916 139.498 36.0403 139.498 32.4573C139.498 28.8756 136.622 26 133.04 26ZM130.021 41.2175C126.545 41.2175 123.727 44.0354 123.727 47.5116C123.727 49.2194 125.112 50.6039 126.819 50.6039H138.908C140.616 50.6039 142 49.2194 142 47.5116C142 44.0354 139.182 41.2175 135.706 41.2175H130.021Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.082 32.4573C127.082 29.1518 129.734 26.5 133.04 26.5V25.5C129.182 25.5 126.082 28.5994 126.082 32.4573H127.082ZM133.04 38.416C129.734 38.416 127.082 35.7642 127.082 32.4573H126.082C126.082 36.3164 129.182 39.416 133.04 39.416V38.416ZM138.998 32.4573C138.998 35.7642 136.346 38.416 133.04 38.416V39.416C136.898 39.416 139.998 36.3164 139.998 32.4573H138.998ZM133.04 26.5C136.346 26.5 138.998 29.1518 138.998 32.4573H139.998C139.998 28.5994 136.898 25.5 133.04 25.5V26.5ZM124.227 47.5116C124.227 44.3116 126.821 41.7175 130.021 41.7175V40.7175C126.269 40.7175 123.227 43.7593 123.227 47.5116H124.227ZM138.908 50.1039H126.819V51.1039H138.908V50.1039ZM135.706 41.7175C138.906 41.7175 141.5 44.3116 141.5 47.5116H142.5C142.5 43.7593 139.458 40.7175 135.706 40.7175V41.7175ZM130.021 41.7175H135.706V40.7175H130.021V41.7175ZM138.908 51.1039C140.892 51.1039 142.5 49.4955 142.5 47.5116H141.5C141.5 48.9433 140.339 50.1039 138.908 50.1039V51.1039ZM123.227 47.5116C123.227 49.4955 124.835 51.1039 126.819 51.1039V50.1039C125.388 50.1039 124.227 48.9433 124.227 47.5116H123.227Z",
    fill: "#D6FFFD",
    mask: "url(#path-7-inside-1_12461_206951)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter6_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 111,
    r: 16,
    fill: "url(#paint0_radial_12461_206951)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 111,
    r: 15.5,
    stroke: "url(#paint1_radial_12461_206951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 118.333H21.5C20.9477 118.333 20.5 117.886 20.5 117.333V104.583H30.5C31.0523 104.583 31.5 105.031 31.5 105.583V109.625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6885 111.917C27.5587 112.638 27.1554 113.291 26.6959 113.833C26.2578 114.35 25.7353 114.826 25.1481 115.151C24.7127 115.392 24.2515 115.571 23.755 115.583C23.4502 115.59 23.258 115.536 23.2503 115.176C23.2363 114.519 23.6881 113.988 24.1857 113.639C24.7914 113.214 25.5174 112.952 26.2495 112.952C26.5577 112.952 26.8635 112.975 27.0627 113.245C27.231 113.474 27.3722 113.725 27.5584 113.939C27.7355 114.142 27.9854 114.321 28.2471 114.371C28.7838 114.474 29.3048 114.508 29.8241 114.319C30.1242 114.21 30.402 114.052 30.6922 113.919C30.8231 113.859 30.9211 113.817 31.0646 113.86C31.3786 113.954 31.6212 114.242 31.8924 114.42C32.2364 114.646 32.6222 114.769 33.0185 114.631C33.3333 114.521 33.6224 114.342 33.9337 114.223C34.0357 114.184 34.1547 114.179 34.25 114.13",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 130,
    r: 22,
    fill: "url(#paint2_radial_12461_206951)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 130,
    r: 21.5,
    stroke: "url(#paint3_radial_12461_206951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132 140.667H125C124.448 140.667 124 140.219 124 139.667V120.667H139C139.552 120.667 140 121.114 140 121.667V128",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.456 131.333C134.267 132.383 133.681 133.333 133.012 134.122C132.375 134.874 131.615 135.565 130.761 136.038C130.128 136.388 129.457 136.65 128.735 136.666C128.291 136.676 128.012 136.598 128 136.075C127.98 135.119 128.637 134.347 129.361 133.839C130.242 133.221 131.298 132.839 132.363 132.839C132.811 132.839 133.256 132.873 133.546 133.267C133.791 133.599 133.996 133.964 134.267 134.275C134.524 134.57 134.888 134.83 135.269 134.903C136.049 135.053 136.807 135.103 137.562 134.828C137.999 134.67 138.403 134.439 138.825 134.246C139.015 134.159 139.158 134.098 139.367 134.161C139.823 134.297 140.176 134.716 140.571 134.975C141.071 135.304 141.632 135.483 142.209 135.281C142.667 135.121 143.087 134.862 143.54 134.689C143.688 134.632 143.861 134.625 144 134.552",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter8_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 119,
    r: 18,
    fill: "url(#paint4_radial_12461_206951)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 119,
    r: 17.5,
    stroke: "url(#paint5_radial_12461_206951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192 127.667H186.5C185.948 127.667 185.5 127.219 185.5 126.667V111.417H197.5C198.052 111.417 198.5 111.864 198.5 112.417V117.375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.996 120.083C193.842 120.936 193.365 121.708 192.822 122.349C192.305 122.96 191.687 123.521 190.993 123.906C190.479 124.19 189.934 124.403 189.347 124.416C188.987 124.424 188.759 124.361 188.75 123.936C188.734 123.159 189.268 122.532 189.856 122.119C190.572 121.617 191.43 121.307 192.295 121.307C192.659 121.307 193.02 121.335 193.256 121.654C193.455 121.924 193.622 122.221 193.842 122.473C194.051 122.713 194.346 122.925 194.656 122.984C195.29 123.105 195.906 123.146 196.519 122.923C196.874 122.794 197.202 122.607 197.545 122.45C197.7 122.379 197.816 122.33 197.985 122.381C198.357 122.491 198.643 122.831 198.964 123.042C199.37 123.309 199.826 123.455 200.295 123.291C200.667 123.161 201.008 122.95 201.376 122.81C201.497 122.763 201.637 122.758 201.75 122.699",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter9_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 119,
    r: 18,
    fill: "url(#paint6_radial_12461_206951)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 119,
    r: 17.5,
    stroke: "url(#paint7_radial_12461_206951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70 127H65C64.4477 127 64 126.552 64 126V112H75C75.5523 112 76 112.448 76 113V117.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8421 120C71.7004 120.787 71.2604 121.5 70.7592 122.091C70.2812 122.655 69.7112 123.174 69.0706 123.528C68.5957 123.791 68.0925 123.987 67.551 123.999C67.2184 124.007 67.0087 123.948 67.0003 123.556C66.9851 122.839 67.478 122.26 68.0208 121.879C68.6815 121.415 69.4735 121.129 70.2722 121.129C70.6084 121.129 70.942 121.155 71.1593 121.45C71.343 121.699 71.497 121.973 71.7001 122.206C71.8933 122.427 72.1658 122.623 72.4514 122.677C73.0369 122.79 73.6053 122.827 74.1718 122.621C74.4991 122.502 74.8022 122.329 75.1188 122.184C75.2616 122.119 75.3685 122.074 75.525 122.12C75.8676 122.223 76.1322 122.537 76.428 122.731C76.8033 122.978 77.2242 123.112 77.6565 122.961C77.9999 122.841 78.3153 122.646 78.6549 122.516C78.7662 122.474 78.896 122.468 79 122.414",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_12461_206951)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 111,
    r: 16,
    fill: "url(#paint8_radial_12461_206951)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 111,
    r: 15.5,
    stroke: "url(#paint9_radial_12461_206951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236 118.333H231.5C230.948 118.333 230.5 117.886 230.5 117.333V104.583H240.5C241.052 104.583 241.5 105.031 241.5 105.583V109.625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.689 111.917C237.559 112.638 237.155 113.291 236.696 113.833C236.258 114.35 235.735 114.826 235.148 115.151C234.713 115.392 234.251 115.571 233.755 115.583C233.45 115.59 233.258 115.536 233.25 115.176C233.236 114.519 233.688 113.988 234.186 113.639C234.791 113.214 235.517 112.952 236.25 112.952C236.558 112.952 236.863 112.975 237.063 113.245C237.231 113.474 237.372 113.725 237.558 113.939C237.735 114.142 237.985 114.321 238.247 114.371C238.784 114.474 239.305 114.508 239.824 114.319C240.124 114.21 240.402 114.052 240.692 113.919C240.823 113.859 240.921 113.817 241.065 113.86C241.379 113.954 241.621 114.242 241.892 114.42C242.236 114.646 242.622 114.769 243.018 114.631C243.333 114.521 243.622 114.342 243.934 114.223C244.036 114.184 244.155 114.179 244.25 114.13",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12461_206951",
    x: 145.192,
    y: 50.161,
    width: 110.866,
    height: 60.8664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.78082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.90411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 1 0 0 0 0 0.992157 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12461_206951",
    x: 9.94178,
    y: 50.161,
    width: 114.866,
    height: 60.8664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.78082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.90411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 1 0 0 0 0 0.992157 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12461_206951",
    x: 114.942,
    y: 30.411,
    width: 96.1164,
    height: 86.6164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.78082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.90411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 1 0 0 0 0 0.992157 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_12461_206951",
    x: 53.9418,
    y: 30.411,
    width: 97.1164,
    height: 86.6164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.78082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.90411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 1 0 0 0 0 0.992157 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_12461_206951",
    x: 114.898,
    y: 41.3292,
    width: 36.1601,
    height: 82.7004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.78082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.90411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 1 0 0 0 0 0.992157 0 0 0 0.63 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_12461_206951",
    x: 104.727,
    y: 7,
    width: 56.2729,
    height: 62.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_12461_206951",
    x: -25,
    y: 61,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_12461_206951",
    x: 75,
    y: 74,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_12461_206951",
    x: 139,
    y: 67,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_12461_206951",
    x: 17,
    y: 67,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_12461_206951",
    x: 185,
    y: 61,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12461_206951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12461_206951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35 103.727) rotate(108.97) scale(24.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 111) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.974931,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D0DB",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144 120) rotate(108.97) scale(33.8378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133 130) rotate(90) scale(22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.974931,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D0DB",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202 110.818) rotate(108.97) scale(27.6855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193 119) rotate(90) scale(18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.974931,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D0DB",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 110.818) rotate(108.97) scale(27.6855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71 119) rotate(90) scale(18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.974931,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D0DB",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245 103.727) rotate(108.97) scale(24.6093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#865A74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12461_206951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237 111) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.974931,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D0DB",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12461_206951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12461_206951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 48,
    fill: "white",
    transform: "translate(132 62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingEntities);
export default __webpack_public_path__ + "static/media/holding-entities.7e688b2c3a11b6a2ef8776e8e3ffb20d.svg";
export { ForwardRef as ReactComponent };